import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import InstallmentsModal from "components/InstallmentsModal";
import { trackResumoCompraEvent } from "utils/gtm";
import { BrlFormatCurrency } from "../../../lib";

const Label = styled.div`
  font-size: 16px;
  color: #707070;
  margin: 16px 0 8px;
`;

const Trigger = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 14px 16px;
  background: #f5f5f7;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  color: ${(p) => (p.$placeholder ? "#707070" : "var(--text-dark, #1D1D1F)")};
  cursor: pointer;
  text-align: left;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default function InstallmentsTrigger({
  installments,
  selected,
  onSelect,
  disabled,
}) {
  const [open, setOpen] = useState(false);

  const selectedObj =
    installments?.find(
      (i) => Number(i.installmentNumber) === Number(selected),
    ) || null;

  const label = selectedObj
    ? Number(selectedObj.installmentNumber) === 1
      ? "Pagamento à vista"
      : `${selectedObj.installmentNumber}x de ${BrlFormatCurrency(
          selectedObj.installmentPrice,
        )}`
    : "Em quantas parcelas deseja pagar?";

  return (
    <>
      <Label>Parcelamentos disponíveis:</Label>
      <Trigger
        type="button"
        $placeholder={!selectedObj}
        disabled={disabled || !installments?.length}
        onClick={() => {
          trackResumoCompraEvent({ title: "abrir-parcelamento" });
          setOpen(true);
        }}
      >
        <span>{label}</span>
        <span>⌄</span>
      </Trigger>
      <InstallmentsModal
        open={open}
        onClose={() => setOpen(false)}
        installments={installments || []}
        selected={selected}
        onSelect={(n) => {
          trackResumoCompraEvent({ title: "selecionar-parcela", parcela: n });
          onSelect(n);
          setOpen(false);
        }}
      />
    </>
  );
}

InstallmentsTrigger.propTypes = {
  installments: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
